import { render } from "./DesktopNavbar.vue?vue&type=template&id=3b806deb&scoped=true"
import script from "./DesktopNavbar.vue?vue&type=script&lang=js"
export * from "./DesktopNavbar.vue?vue&type=script&lang=js"

import "./DesktopNavbar.vue?vue&type=style&index=0&id=3b806deb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b806deb"]])

export default __exports__